import {createConfirmation} from 'react-confirm';
import ConfirmDialog from 'components/pure/utils/ConfirmDialog';

const confirm = createConfirmation(ConfirmDialog);

export default function (confirmation, title?, options = {}): Promise<boolean> {
  return confirm({confirmation, options, title});
}
